// extracted by mini-css-extract-plugin
export var container = "_fp-0";
export var content = "_fp-3";
export var customerTitle = "_fp-4";
export var empty = "_fp-5";
export var gray = "_fp-6";
export var header = "_fp-7";
export var info = "_fp-8";
export var loading = "_fp-2";
export var loadingCard = "_fp-9";
export var oneLine = "_fp-a";
export var personName = "_fp-e";
export var pillContainer = "_fp-b";
export var selected = "_fp-1";
export var text = "_fp-c";
export var twoLines = "_fp-d";
export var unread = "_fp-f";
export var unreadIndicator = "_fp-g";